import { entity } from 'simpler-state';

import { MarketCapCategory } from '../../models/fundamental/types';
import { DEFAULT_MARKET_CAPS_CATEGORY } from '../fundamental/constants';

/**
 * Persists the selected market cap bucket so the Market Cap Radar widget keeps its selection
 * across remounts. Defaults to the mid caps.
 */
export const marketCapRadarCategory = entity<MarketCapCategory>(DEFAULT_MARKET_CAPS_CATEGORY);

export const setMarketCapRadarCategory = (newCategory: MarketCapCategory): void => {
  marketCapRadarCategory.set(newCategory);
};
